const actions = {
  SET_FILE_STATE: "SET_FILE_STATE",
  SET_META_DATA: "SET_META_DATA",
  SET_LOCATION: "SET_LOCATION",
  RESET_STATE: "RESET_STATE"
};

export default actions;